import { render, staticRenderFns } from "./FeatureNotAvailable.vue?vue&type=template&id=2c39f48e&"
import script from "./FeatureNotAvailable.vue?vue&type=script&lang=js&"
export * from "./FeatureNotAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports